// extracted by mini-css-extract-plugin
module.exports = {"cardMain":"Card_cardMain__mnt5D","info":"Card_info__GRu8G","cardImg":"Card_cardImg__wuVlM","name":"Card_name__cPP2m","desc":"Card_desc__ZdIZA"};